import script from "./DrUniversityFounders.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrUniversityFounders.vue?vue&type=script&setup=true&lang=ts"

import "./DrUniversityFounders.vue?vue&type=style&index=0&id=7929dc55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7929dc55"]])

export default __exports__